import * as yup from 'yup';
import {
  MAX_DEFAULT_BIG_FIELD_SYMBOLS,
  MAX_DEFAULT_FIELD_SYMBOLS,
} from 'constants/general';
import type { TLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.types';

export const getLocalizationFormSchema = (localize: TLocalize) =>
  yup.object().shape({
    key: yup
      .string()
      .required(
        localize('validation.admin.localization.key.required') as string
      )
      .max(
        MAX_DEFAULT_FIELD_SYMBOLS,
        localize('validation.admin.localization.key.max', [
          String(MAX_DEFAULT_FIELD_SYMBOLS),
        ]) as string
      )
      .lowercase(
        localize('validation.admin.localization.key.lowercase') as string
      ),
    value: yup
      .string()
      .required(
        localize('validation.admin.localization.value.required') as string
      )
      .max(
        MAX_DEFAULT_BIG_FIELD_SYMBOLS,
        localize('validation.admin.localization.value.max', [
          String(MAX_DEFAULT_BIG_FIELD_SYMBOLS),
        ]) as string
      ),
  });
